/*
  Where things are under /y, named once.

  The Loops upsell sent people to /y/settings/billings, a path that has never been
  a route — the page lives at /y/settings/subscriptions (the folder is still called
  `billings`, which is how the wrong word got typed). Links into Settings read
  these, and routes.tsx declares its Settings children from the same segments, so
  a link and its route cannot drift apart again; routes.test.tsx checks it.
*/

export const SETTINGS_ROOT = "/y/settings";

/** The Settings children, as route segments. */
export const SETTINGS_SECTIONS = {
  profile: "profile",
  subscriptions: "subscriptions",
  branes: "branes",
  notifications: "notifications",
  devices: "devices",
  appearance: "appearance",
  blocked: "blocked",
} as const;

export type SettingsSection = keyof typeof SETTINGS_SECTIONS;

/** The absolute path to a Settings page, e.g. `settingsPath("subscriptions")`. */
export const settingsPath = (section: SettingsSection) =>
  `${SETTINGS_ROOT}/${SETTINGS_SECTIONS[section]}`;

/*
  Explore Knots is a modal on the Knots list, not a route. The finder's "Explore
  Knots" action reaches it through this query parameter, which the Knots list
  reads once and then drops, so Back does not reopen it.
*/
export const EXPLORE_KNOTS_PARAM = "explore";

export const exploreKnotsPath = `/y/knots?${EXPLORE_KNOTS_PARAM}=1`;
